export const MAIN = 'main';
export const REGISTRATION = 'registration';
export const FEED = 'feed';
export const COMMON_FEED = 'common_feed';
export const PROFILE = 'PROFILE';
export const PROFILE_REDIRECT = 'profile_redirect';
export const SEARCH = 'search';
export const NOTIFY = 'notify';
export const OTHER = 'other';
export const INVITE = 'INVITE';
export const GROUP = 'GROUP';
export const GROUPS = 'GROUPS';
export const IM = 'IM';
export const BUY_MESSAGE_FAILED = 'BUY_MESSAGE_FAILED';
export const PAY_TIPS_FAILED = 'PAY_TIPS_FAILED';
export const CHAT = 'CHAT';
export const MEDIA = 'MEDIA';
export const BROADCAST = 'BROADCAST';
export const BROADCAST_MESSAGE = 'BROADCAST_MESSAGE';
export const BROADCAST_STATS = 'BROADCAST_STATS';
export const AUTH_REQUIRED = 'auth_required';
export const AUTH_PAGE = 'auth_page';
export const ACCESS_DENIED = 'access_denied';
export const FIND_FRIENDS = 'FIND_FRIENDS';
export const RESOLVE = 'RESOLVE';
export const VK_AUTH = 'VK_AUTH';
export const AUTH = 'AUTH';
export const AUTH_EMAIL = 'AUTH_EMAIL';
export const SETTINGS = 'SETTINGS';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const CONTENT_PRIORITY = 'CONTENT_PRIORITY';
export const GENDER_FILTER = 'GENDER_FILTER';
export const LANGUAGE = 'LANGUAGE';
export const PASSWORD = 'PASSWORD';
export const PROMO = 'PROMO';
export const RATING = 'RATING';
export const BIRTHDAYS = 'BIRTHDAYS';
export const LIKES = 'LIKES';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED';
export const SUBSCRIPTION_AUTHOR_OLD = 'SUBSCRIPTION_AUTHOR_OLD';
export const SUBSCRIPTION_AUTHOR = 'SUBSCRIPTION_AUTHOR';
export const SUBSCRIPTION_MEDIA = 'SUBSCRIPTION_MEDIA';

export const SUBSCRIPTION_BASIC = 'SUBSCRIPTION_BASIC';

export const SUBSCRIPTION_ADULT = 'SUBSCRIPTION_ADULT';
export const CANDY_QR = 'CANDY_QR';

export const TRIAL_LINKS = 'TRIAL_LINKS';
export const BLOCKED = 'BLOCKED';
export const COUNTRY_BLOCKED = 'COUNTRY_BLOCKED';
export const SUBSCRIPTION_AUTHOR_ACTIVATED = 'SUBSCRIPTION_AUTHOR_ACTIVATED';
export const SUBSCRIPTION_MEDIA_ACTIVATED = 'SUBSCRIPTION_MEDIA_ACTIVATED';
export const SUBSCRIPTION_ADULT_ACTIVATED = 'SUBSCRIPTION_ADULT_ACTIVATED';
export const SUBSCRIPTION_ACTIVATED = 'SUBSCRIPTION_ACTIVATED';
export const AGENT = 'AGENT';
export const REF = 'ref';
export const USER_REF = 'USER_REF';
export const MODEL_UTM = 'MODEL_UTM';
export const NOTIFY_SETTINGS = 'NOTIFY_SETTINGS';
export const VERIFICATION_LANDING = 'VERIFICATION_LANDING';
export const VERIFICATION_APPLY = 'MONETIZATION';
export const SUBSCRIPTION_TONKEEPER = 'SUBSCRIPTION_TONKEEPER';
export const SUBSCRIPTION_INFO = 'SUBSCRIPTION_INFO';
export const PAY_FORM = 'PAY_FORM';
export const EXPLORE = 'EXPLORE';
export const HOWTO = 'HOWTO';
export const FAQ = 'faq';
export const SUBSCRIPTIONS = 'SUBSCRIPTIONS';
export const PERSONAL_SUBSCRIPTION = 'PERSONAL_SUBSCRIPTION';
export const PERSONAL_SUBSCRIPTION_INFO = 'PERSONAL_SUBSCRIPTION_INFO';
export const STATISTICS = 'STATISTICS';
export const STATISTICS_PRO = 'STATISTICS_PRO';
export const STATISTICS_PRO_FANS = 'STATISTICS_PRO_FANS';
export const STATISTICS_PRO_LINKS = 'STATISTICS_PRO_LINKS';
export const STORAGE = 'STORAGE';
export const SESSIONS = 'SESSIONS';
export const PASSKEY = 'PASSKEY';
export const API_TOKEN = 'API_TOKEN';
export const OAUTH_AUTHORIZE = 'OAUTH_AUTHORIZE';
export const WEBSITE_SETTINGS = 'WEBSITE_SETTINGS';
export const NFT = 'NFT';
export const SHARE_PROFILE = 'SHARE_PROFILE';
export const WELCOME_MESSAGE = 'WELCOME_MESSAGE';
export const ADULT_AUTH = 'ADULT_AUTH';
export const GOOGLE_AUTH = 'GOOGLE_AUTH';
export const CLOUD = 'CLOUD';
export const ADS = 'ADS';
export const TOP_UP = 'TOP_UP';
export const TOP_UP_FAILED = 'TOP_UP_FAILED';
export const LISTS = 'LISTS';
export const INCOGNITO = 'INCOGNITO';
export const LIST = 'LIST';
export const LIVE = 'LIVE';
export const PROFILE_LIVE = 'PROFILE_LIVE';
export const PRE_LANDING_V1 = 'PRE_LANDING_V1';
export const PRE_LANDING_V2 = 'PRE_LANDING_V2';
export const PRE_LANDING_V3 = 'PRE_LANDING_V3';
export const BATTLE = 'BATTLE';
export const PWA_IOS = 'PWA_IOS';
export const BATTLES = 'BATTLES';
export const STORY_LANDING = 'STORY_LANDING';
export const LANDING_DIAMOND = 'LANDING_DIAMOND';
export const BOT = 'BOT';
export const REF_LANDING = 'REF_LANDING';
export const APP = 'APP';
export const APPS_MANAGE = 'APPS_MANAGE';
export const PROMO_CODE = 'PROMO_CODE';
export const SYSTEM_PROMO_CODE = 'SYSTEM_PROMO_CODE';
export const VALENTINE_DAY_STICKER = 'VALENTINE_DAY_STICKER';
export const REELS = 'REELS';
export const PROFILE_REELS = 'PROFILE_REELS';
export const POST_VIEW = 'POST_VIEW';
export const MARYANA_LANDING = 'MARYANA_LANDING';
export const DASHBOARD = 'DASHBOARD';

export const PAYMENT_METHODS = 'PAYMENT_METHODS';

export const REFILL_TON = 'REFILL_TON';

export const SHOW_SUBSCRIPTION = 'SHOW_SUBSCRIPTION';

export const ISOLATED_MODE = 'ISOLATED_MODE';

export const TELEGRAM = 'TELEGRAM';

export const OFFERS = 'OFFERS';

export const VIEW_OFFER = 'VIEW_OFFER';

export const MINE = 'MINE';
export const MINE_SQUAD = 'MINE_SQUAD';
export const MINE_BOOST = 'MINE_BOOST';
export const MINE_TOP = 'MINE_TOP';
export const MINE_FRIENDS = 'MINE_FRIENDS';
export const MINE_SQUAD_BOOST = 'MINE_SQUAD_BOOST';
export const MINE_EXPLORE = 'MINE_EXPLORE';

export const ONLYPAY_SUCCESS = 'ONLYPAY_SUCCESS';

export const ONLYPAY_ERROR = 'ONLYPAY_ERROR';

export const FEED_PROMOTION = 'FEED_PROMOTION';

export const FREE_WRITE = 'FREE_WRITE';

export const LEADERBOARD = 'LEADERBOARD';

export const LEADERBOARDS_HISTORY = 'LEADERBOARDS_HISTORY';

export const LEADERBOARD_DETAILS = 'LEADERBOARD_DETAILS';

export const CUSTOM_TIPS = 'CUSTOM_TIPS';
export const DEBUG_PAGE = 'debug_page';

export const BLACK_FRIDAY_2025 = 'BLACK_FRIDAY_2025';

export const BLACKLIST = 'BLACKLIST';

export const BIND_EMAIL = 'BIND_EMAIL';
export const BIND_EMAIL_CONFIRM = 'BIND_EMAIL_CONFIRM';

// ADMIN PANEL
export const ADMIN = 'ADMIN';
export const ADMIN_FINANCE = 'ADMIN_FINANCE';
export const ADMIN_USERS = 'ADMIN_USERS';
export const ADMIN_UTM_MODEL_LIST = 'ADMIN_UTM_MODEL_LIST';
export const ADMIN_MODEL_ADS = 'ADMIN_MODEL_ADS';
export const ADMIN_REPORTS = 'ADMIN_REPORTS';
export const ADMIN_SPAM_CASES = 'ADMIN_SPAM_CASES';
export const ADMIN_SPAM_CASE = 'ADMIN_SPAM_CASE';
export const ADMIN_MODERATION = 'ADMIN_MODERATION';
export const ADMIN_MODERATION_VIEW = 'ADMIN_MODERATION_VIEW';
export const ADMIN_MODERATIONS = 'ADMIN_MODERATIONS';
export const ADMIN_MODERATIONS_LIST = 'ADMIN_MODERATIONS_LIST';
export const ADMIN_MODERATION_STATS = 'ADMIN_MODERATION_STATS';
export const ADMIN_MODERATION_QUEUE = 'ADMIN_MODERATION_QUEUE';
export const ADMIN_OTHER = 'ADMIN_OTHER';
export const ADMIN_ADS = 'ADMIN_ADS';
export const ADMIN_USER_PROFILE = 'ADMIN_USER_PROFILE';
export const ADMIN_ACTIONS_STATS = 'ADMIN_ACTIONS_STATS';
export const ADMIN_MESSAGES = 'ADMIN_MESSAGES';
export const ADMIN_CHATS = 'ADMIN_CHATS';
export const ADMIN_BROADCASTS = 'ADMIN_BROADCASTS';
export const ADMIN_TRANSLATIONS = 'ADMIN_TRANSLATIONS';
export const ADMIN_TRANSLATIONS_LANGUAGE = 'ADMIN_TRANSLATIONS_LANGUAGE';
export const ADMIN_TOP = 'ADMIN_TOP';
export const ADMIN_PROMO_CODES = 'ADMIN_PROMO_CODES';
export const ADMIN_PROMO_CODE = 'ADMIN_PROMO_CODE';
export const ADMIN_BATTLE = 'ADMIN_BATTLE';
export const ADMIN_BATTLE_CREATE = 'ADMIN_BATTLE_CREATE';
export const TRIAL_LINK_ACTIVATION = 'TRIAL_LINK_ACTIVATION';
export const ADMIN_WITHDRAWALS = 'WITHDRAWALS';
export const ADMIN_MINE_EXPLORE_CARDS = 'ADMIN_MINE_EXPLORE_CARDS';
export const ADMIN_TRANSACTIONS = 'ADMIN_TRANSACTIONS';

export const ADMIN_AUDIT_LOG = 'ADMIN_AUDIT_LOG';
export const ADMIN_MODERATION_LOGS = 'ADMIN_MODERATION_LOGS';
export const ADMIN_BLACKLIST = 'ADMIN_BLACKLIST';
